import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
  state: () => ({
    answerId: "",
    mbrId: "",
    webCallback: null as (() => void) | null,
    loginRenewalFlag: true, /// 로그인 리뉴얼 적용 여부 플레그
    testSessionKey: "", // TEST 코드 , 추후 삭제.
    
    home: {
      index: 0,
    },

    healthcare: {
      index: 0,
      dietRecords: {
        paramDate: null,
      },
      curationMain : false ,
      curation : false
    },
    
    history: {
      index: 99,
    },

    store: {
      index: 0,
      event: '',
      storeClinic: {
        qnaSeq: null,   // 또박클리닉 문의 고유번호 (수정 시 저장)
        viewQnaSeq: []  // 조회한 문의 고유번호 (조회수 증가 확인)
      }
    },
    
    isCallingAPI: false,
    isCh: false, // 해외전용 여부
    chCategory: ['000100100004'], // 해외전용 카테고리 코드
    apiReload: false,
    isBirth: false,
    cartCount: 0,
  }),
  getters: {

  },  
  actions: {
    // 웹 콜백 실행
    executeWebCallback() {
      if (typeof this.webCallback === 'function') {
        console.log('executeFunction')
        this.webCallback();
        this.webCallback = null;
      }
    },
    saveWebCallback(callback: () => void) {
      this.webCallback = callback;
    },
    clearWebCallback() {
      this.webCallback = null;
    },
    // 해외전용 여부 업데이트
    updateCh(value: boolean) {
      this.isCh = value;
    },
    // 해외전용 카테고리 업데이트
    updateChCategory(list: string[]) {
      this.chCategory = [...list];
    },
    updateApiReload(value: boolean) {
      this.apiReload = value;
    },
    saveCartCount(value: number) {
      this.cartCount = value;
    },
  },
});